const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Mohit Jain</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Photography Head, UPES-CSI</li>
    <li>
        Capturing moments through the lens.
    </li>
    <li>
        Leading photography initiatives for all CSI events.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
